import type { QueryDocumentSnapshot, SnapshotOptions } from "firebase/firestore";
import type { IUser } from "~~/types/user";

export const userConverter = {
  toFirestore(data: IUser): IUser {
    return data;
  },
  fromFirestore(snapshot: QueryDocumentSnapshot, options: SnapshotOptions): IUser {
    const data = snapshot.data(options);

    // Convert permissions from object to array if needed
    let permissions = data.permissions;
    if (typeof permissions === "object" && !Array.isArray(permissions)) {
      permissions = Object.values(permissions);
    }

    return {
      ...data,
      permissions,
    } as IUser;
  },
};
